import { connect } from 'react-redux'

import {
    fetchMedia,
} from '../../actions/Media'
import { openDialog } from '../../actions/Dialog'

import MySwiper from '../../components/MySwiper/MySwiper'

const mapStateToProps = (state) => ({
    videos: state.media.videos,

    isError: state.media.isError,
    isErrorNotFound: state.media.isErrorNotFound,
    isFetching: state.media.isFetching,
    isFetched: state.media.isFetched,
})

const mapDispatchToProps = (dispatch) => ({
    fetchMedia: () => {
        dispatch(fetchMedia('media'))
    },

    showVideoPopup: (content) => {
        dispatch(openDialog(content))
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(MySwiper)
